module.exports = __webpack_public_path__ + "static/media/icon_data-engineers.efd72275.svg";